import {
  CatalogProductDetailViewFragmentFragment,
  CatalogVariantFragmentFragment,
} from '@notino/shared/definitions/types';

export const getProductName = (
  variant: CatalogVariantFragmentFragment,
  product: CatalogProductDetailViewFragmentFragment
): string => {
  const variantDescription =
    variant.attributes && variant.attributes.Master
      ? product.annotation
      : variant.variantName;

  return `${product.brand.name} ${product.collection} ${variantDescription}`;
};
